import Collapse from '@material-ui/core/Collapse';
import MenuList from '@material-ui/core/MenuList';
import LanguageIcon from '@material-ui/icons/Language';
import MessageIcon from '@material-ui/icons/Message';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import * as React from 'react';
import { HasPermissions } from '../../components/HasPermissions';
import { useMiaSelector } from '../../components/hooks';
import { LeftNavHeader } from '../../components/LeftNavHeader';
import { isItOverriddenByType } from '../../ducks/auth';
import { NavTypes, NavUrls } from '../layoutConstants';
import { MenuLink } from '../MenuLink';
import { TargetedCatalogNav } from '../sharedNavs/TargetedCatalogNav';

interface IDealerPortalMenuProps {
  collapsed: boolean;
  menuClassName: string;
  navType: NavTypes;
  onExpandClick: (navType: NavTypes) => any;
  onNavClick: () => any;
  currentLocation: string;
}

let DealerPortalMenu: React.FunctionComponent<IDealerPortalMenuProps> = ({
  collapsed,
  menuClassName,
  navType,
  onExpandClick,
  onNavClick,
  currentLocation
}) => {
  const isNavItOverridden = useMiaSelector(state => isItOverriddenByType(state, 'dealerPortal'));

  React.useEffect(() => {
    if (currentLocation.includes('dealerPortal') || currentLocation.includes('targetedCatalog')) {
      onExpandClick('dealerPortal');
    }
  }, []);

  return (
    <HasPermissions type="dealerPortal">
      <LeftNavHeader
        collapsed={collapsed}
        navType={navType}
        onExpandClick={onExpandClick}
        icon={ShoppingCartIcon}
        title="Dealer Portal"
        hasWarningColor={isNavItOverridden}
      />
      <Collapse component="li" in={collapsed} timeout="auto" unmountOnExit>
        <MenuList disablePadding>
          <MenuLink
            icon={<MessageIcon />}
            to={NavUrls.dealerPortalNewsFeed}
            label="News Feed"
            menuClassName={menuClassName}
            onNavClick={onNavClick}
            isActive={NavUrls.dealerPortalNewsFeed === currentLocation}
          />
          <TargetedCatalogNav
            menuClassName={menuClassName}
            onNavClick={onNavClick}
            isActive={NavUrls.targetedCatalog === currentLocation}
          />
          <MenuLink
            icon={<LanguageIcon />}
            to={NavUrls.dealerPortalFreeShipping}
            label="Free Shipping"
            menuClassName={menuClassName}
            onNavClick={onNavClick}
            isActive={NavUrls.dealerPortalFreeShipping === currentLocation}
          />
        </MenuList>
      </Collapse>
    </HasPermissions>
  );
};

DealerPortalMenu = React.memo<IDealerPortalMenuProps>(DealerPortalMenu);
export { DealerPortalMenu };
